import { render, staticRenderFns } from "./ConflictedPayslipRow.vue?vue&type=template&id=2000d3fe&scoped=true"
import script from "./ConflictedPayslipRow.vue?vue&type=script&lang=js"
export * from "./ConflictedPayslipRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2000d3fe",
  null
  
)

export default component.exports